import { object, string } from 'yup';

export const keyIndividualsValidations = {
  designation: object()
    .shape({
      value: string().required('Please select designation'),
      label: string().required('Please select designation'),
    })
    .nullable()
    .required('Please select designation')
    .typeError('Please select designation'),

  percentageHoldingIsRequired: object()
    .shape({
      value: string().required('Please select beneficiary percentage holding'),
      label: string().required('Please select beneficiary percentage holding'),
    })
    .nullable()
    .typeError('Please select beneficiary percentage holding')
    .required('Please select beneficiary percentage holding'),

  uboEntity: object()
    .shape({
      value: string(),
      label: string().required('Please select beneficiary information'),
      code: string(),
    })
    .nullable()
    .typeError('Please select beneficiary information')
    .required('Please select beneficiary information'),
};
